export const FETCH_LOCATION = 'FETCH_LOCATION';
export const SET_NOTIF = 'SET_NOTIF';

export const SET_MODIFIERS = 'SET_MODIFIERS';
export const SET_MODIFIERS_SELECTED = 'SET_MODIFIERS_SELECTED';
export const SET_PRODUCT = 'SET_PRODUCT';
export const SET_PRODUCT_SELECTED = 'SET_PRODUCT_SELECTED';
export const SET_CLEAR_NOTIF = 'SET_CLEAR_NOTIF';

//For ingredients library
export const SET_STOCK_INGREDIENT = 'SET_STOCK_INGREDIENT';
export const SET_INFLOW = 'SET_INFLOW';
export const SET_OUTFLOW = 'SET_OUTFLOW';

//For role access
export const SET_ACCESS_ROLE = 'SET_ACCESS_ROLE';
export const SET_ACCESS_ACTIVE_ROLE = 'SET_ACCESS_ACTIVE_ROLE';
export const SET_ACCESS_ACTIVE_ROLE_CHECKED = 'SET_ACCESS_ACTIVE_ROLE_CHECKED';
export const SET_ROLE_NAME = 'SET_ROLE_NAME';
export const SET_ROLE_INVITES = 'SET_ROLE_INVITES';
export const SET_ROLE_ID = 'SET_ROLE_ID';

//For registrastion
export const SET_OWNER = 'SET_OWNER';
export const SET_BUSINESS = 'SET_BUSINESS';
export const SET_ACCOUNT = 'SET_ACCOUNT';
export const SET_DEFAULT_BUSINESS = 'SET_DEFAULT_BUSINESS';
export const SET_DEFAULT_SIZE = 'SET_DEFAULT_SIZE';
export const SET_DEFAULT_PROVINCE = 'SET_DEFAULT_PROVINCE';
export const SET_DEFAULT_CITY = 'SET_DEFAULT_CITY';
